import React, { useState } from 'react';
// 1. استيراد دوال الفايربيز
import { db } from '../firebaseConfig'; // تأكد من صحة المسار
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const Contact = ({ lang }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // تعريف الـ State لتخزين المدخلات
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const content = {
    ar: {
      title: "تواصل معنا",
      heading: "نحن هنا لخدمتك",
      desc: "تفضل بزيارتنا في مقرنا أو تواصل معنا عبر الهاتف أو البريد الإلكتروني للحصول على استشارة قانونية.",
      address: "3 شارع المساحة - الدقي - الجيزة - مصر",
      phone: "02/333 693 77",
      mobile: "+20 122 733 2351",
      email: "moh@elwakillaw.com",
      form: {
        name: "الاسم بالكامل",
        email: "البريد الإلكتروني",
        subject: "الموضوع",
        message: "رسالتك",
        btn: "إرسال الرسالة",
        loading: "جاري الإرسال...",
        success: "تم إرسال رسالتك بنجاح، سنرد عليك في أقرب وقت."
      }
    },
    en: {
      title: "Contact Us",
      heading: "We Are Here For You",
      desc: "Visit our office or contact us via phone or email for legal consultation.",
      address: "3 El-Mesaha St - Dokki - Giza - Egypt",
      phone: "02/333 693 77",
      mobile: "+20 122 733 2351",
      email: "moh@elwakillaw.com",
      form: {
        name: "Full Name",
        email: "Email Address",
        subject: "Subject",
        message: "Your Message",
        btn: "Send Message",
        loading: "Sending...",
        success: "Message sent successfully, we will reply shortly."
      }
    }
  };

  const t = content[lang];
  const isAr = lang === 'ar';

  // تحديث البيانات عند الكتابة
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // دالة الإرسال لفايربيز
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // الإرسال إلى Collection اسمها "messages"
      await addDoc(collection(db, "messages"), {
        ...formData,
        read: false, // حقل لتمييز الرسالة بأنها غير مقروءة في لوحة التحكم
        createdAt: serverTimestamp(),
        lang: lang // لمعرفة لغة المرسل
      });

      alert(t.form.success);
      
      // تفريغ النموذج
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });

    } catch (error) {
      console.error("Error sending message: ", error);
      alert(isAr ? "حدث خطأ، يرجى المحاولة لاحقاً" : "Error occurred, please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact-section" id="contact" dir={isAr ? 'rtl' : 'ltr'}>
      <div className="container">
        
        <div className="contact-wrapper">
          
          {/* جزء معلومات الاتصال */}
          <div className="contact-info">
            <h4 className="contact-subtitle">{t.title}</h4>
            <h2 className="contact-heading">{t.heading}</h2>
            <p className="contact-desc">{t.desc}</p>
            
            <div className="info-item">
              <div className="icon-box">📍</div>
              <div className="info-text">
                <h3>{isAr ? 'العنوان' : 'Address'}</h3>
                <p>{t.address}</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon-box">📞</div>
              <div className="info-text">
                <h3>{isAr ? 'الهاتف' : 'Phone'}</h3>
                <p dir="ltr" className={isAr ? "text-right" : ""}>{t.phone}</p>
                <p dir="ltr" className={isAr ? "text-right" : ""}>{t.mobile}</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon-box">✉️</div>
              <div className="info-text">
                <h3>{isAr ? 'البريد الإلكتروني' : 'Email'}</h3>
                <p>{t.email}</p>
              </div>
            </div>
          </div>

          {/* جزء النموذج (Form) */}
          <div className="contact-form-wrapper">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input 
                  type="text" 
                  name="name"
                  placeholder={t.form.name} 
                  className="form-input" 
                  value={formData.name}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <input 
                  type="email" 
                  name="email"
                  placeholder={t.form.email} 
                  className="form-input" 
                  value={formData.email}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <input 
                  type="text" 
                  name="subject"
                  placeholder={t.form.subject} 
                  className="form-input" 
                  value={formData.subject}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <textarea 
                  name="message"
                  placeholder={t.form.message} 
                  className="form-input textarea" 
                  rows="5" 
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button 
                type="submit" 
                className="submit-btn"
                disabled={isSubmitting}
                style={{ opacity: isSubmitting ? 0.7 : 1 }}
              >
                {isSubmitting ? t.form.loading : t.form.btn}
              </button>
            </form>
          </div>

        </div>
      </div>
      
      {/* الحقوق والفوتر البسيط */}
      <div className="footer-bottom">
        <p>© 2025 El-Wakil Law Firm. All Rights Reserved.</p>
      </div>
    </section>
  );
};

export default Contact;